import React from 'react'
import { Modal } from '@winnin/winnin_ui.components.modal'
import { Title } from '@winnin/winnin_ui.components.title'

import { useDashboardModals } from 'contexts/DashboardModalsContext'
import { T } from 'lib/tolgee'
import { analyticsTracker } from 'utils'

import CreateDashboardModalFirstStep from './components/CreateDashboardModalFirstStep'
import CreateDashboardModalSecondStep from './components/CreateDashboardModalSecondStep'

import './index.scss'

const { CLOSE_MODAL } = analyticsTracker.eventNames

const TOLGEE_PREFFIX = 'CreateDashboardModal'

const MODAL_STYLE = {
  overlay: {
    backgroundColor: 'rgba(0, 0, 0, 0.80)',
    overflowY: 'overlay',
    zIndex: 999,
  },
  content: {
    width: '80%',
    maxWidth: '586px',
    position: 'absolute',
    top: '50%',
    right: 'unset',
    left: '50%',
    bottom: 'unset',
    transform: 'translate(-50%, -50%)',
    border: 'none',
    padding: 'var(--spacing_unit_6)',
    overflow: 'unset',
    borderRadius: '8px',
  },
}

export default function CreateDashboardModal() {
  const {
    createDashboardStep,
    isCreateDashboardModalOpen,
    setIsCreateDashboardModalOpen,
    setDashboard,
    setCreateDashboardStep,
  } = useDashboardModals()

  function handleCloseModal() {
    analyticsTracker.eventTrack(CLOSE_MODAL, {
      modalType: 'Job Create',
    })

    setDashboard({})
    setCreateDashboardStep(1)
    setIsCreateDashboardModalOpen(false)
  }

  return (
    <Modal
      isOpen={isCreateDashboardModalOpen}
      style={MODAL_STYLE}
      onRequestClose={handleCloseModal}
      appElement={document.body}
    >
      <div className="CreateDashboardModal">
        <Title tag="h3" className="CreateDashboardModal-title">
          <T keyName={`${TOLGEE_PREFFIX}-title`}>Começar um novo dashboard</T>
        </Title>

        {createDashboardStep === 1 && <CreateDashboardModalFirstStep />}

        {createDashboardStep === 2 && <CreateDashboardModalSecondStep />}
      </div>
    </Modal>
  )
}
